<template>
  <div
    v-if="userData"
    class="home-welcome"
  >
    <h1 class="mb-0">
      Bienvenido, {{ userData.fullName }}
    </h1>
    <p class="text-muted mb-0">
      Portal de clientes de {{ business.name }}
    </p>
  </div>
</template>

<script>
import business from "@/business"

export default {
  data() {
    return {
      business,
      userData: JSON.parse(localStorage.getItem("userData")),
    }
  },
}
</script>

<style lang="scss" scoped>
.home-welcome {
    padding: 0.5rem 0 1.5rem;

    h1 {
        font-size: 1.875rem;
        font-weight: 700;
        letter-spacing: -0.01em;
    }

    p {
        font-size: 0.9375rem;
    }
}
</style>
